import React, { useEffect } from "react";
import { ThemeProvider } from "@material-ui/styles";
import * as constants from "./constants";
import { CssBaseline } from "@material-ui/core";
import Layout from "./components/Layout";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import Home from "./components/pages/Home";
import Page from "./components/pages/Page";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./index.css";
import "react-image-lightbox/style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ScrollMemory from "react-router-scroll-memory";

function App() {
  return (
    <BrowserRouter>
      <ScrollMemory />
      <ThemeProvider theme={constants.THEME}>
        <CssBaseline />
        <Layout>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/:page" component={Page} />
          </Switch>
        </Layout>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
